import { motion } from "motion/react";
import { ShaderAnimation } from "./ui/shader-lines";

export default function LoadingScreen() {
  return (
    <motion.div
      initial={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1, ease: "easeInOut" }}
      className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-black overflow-hidden"
    >
      <ShaderAnimation />
      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        exit={{ opacity: 0, scale: 1.05 }}
        transition={{ delay: 0.5, duration: 1 }}
        className="relative z-10 flex flex-col items-center justify-center pointer-events-none"
      >
        <div className="text-white font-heading text-5xl md:text-7xl lg:text-8xl tracking-tight italic">
          EsyAI
        </div>
        <div className="text-white/60 font-body text-sm tracking-[0.2em] uppercase mt-2">
          Make Life Esy
        </div>
      </motion.div>
    </motion.div>
  );
}
